import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './lib/api.js';
import SignIn from './screens/SignIn.jsx';
import UpdateBanner from './components/UpdateBanner.jsx';
import Trips from './screens/Trips.jsx';
import Trip from './screens/Trip.jsx';

export default function App() {
  const [session, setSession] = useState(undefined);   // undefined = still checking

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  if (session === undefined) return <div className="spinner" aria-label="Caricamento" />;
  if (!session) return <SignIn />;

  return (
    <>
    <UpdateBanner />
    <Routes>
      <Route path="/" element={<Trips />} />
      <Route path="/trip/:id" element={<Trip />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
